import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import { DragSource } from 'react-dnd';
import { compose, isMobileOrTablet } from '../../../utility';
import TextBoxIcon from '../../../assets/text.svg';
import c from '../../constants';
import styles from './textbox.styles';
import { textboxPreview } from './dragPreview';

const checkboxSource = {
  beginDrag(props) {
    const { id } = props;
    return { id };
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview(),
  };
}

type PropType = {
  connectDragPreview: Function,
  connectDragSource: Function,
  handleClick: Function,
  handleKeyDown: Function,
  classes: Object
}

class TextboxC extends React.PureComponent<PropType, *> {

  componentDidMount() {
    if (!isMobileOrTablet()) {
      const preview = new Image();
      preview.src = textboxPreview;
      preview.onload = () => this.props.connectDragPreview && this.props.connectDragPreview(preview, { offsetX: 0, offsetY: 0 });
    }
  }

  render() {
    const {
      connectDragSource, handleClick, classes, handleKeyDown,
    } = this.props;

    return (connectDragSource && connectDragSource(
      <div
        role="button"
        tabIndex="0"
        onKeyDown={ev => handleKeyDown(ev, c.ItemTypes.TEXT)}
        onClick={ev => handleClick(ev, c.ItemTypes.TEXT)}
        className={classNames(classes.root, 'fieldOutClick')}
        data-testid="textboxTool"
      >
        <TextBoxIcon />
        <span className={classes.legend}>Text</span>
      </div>,
    ));
  }

}

export const Textbox = compose(
  DragSource(c.ItemTypes.TEXT, checkboxSource, collect),
  withStyles(styles, { withTheme: true }),
)(TextboxC);
